import React, { useState } from "react";
import { Plus, Check } from "lucide-react";
import { useCart } from "@/context/CartContext";

const formatINR = (n) => `\u20b9${n.toLocaleString("en-IN")}`;

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);

  const handleAdd = (e) => {
    e.preventDefault();
    addToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <a
      href={`#product-${product.slug}`}
      className="group block bg-[#111112] border border-[#1c1c1e] hover:border-[#c9a24a]/50 transition-colors"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0b0b0c]">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-[900ms] ease-out"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0c]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <button
          onClick={handleAdd}
          className="absolute bottom-4 left-4 right-4 flex items-center justify-center gap-2 bg-[#c9a24a] text-[#0b0b0c] py-3 text-[12px] uppercase tracking-[0.2em] font-medium translate-y-4 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
        >
          {added ? (
            <>
              <Check size={14} /> Added
            </>
          ) : (
            <>
              <Plus size={14} /> View & Add
            </>
          )}
        </button>
      </div>
      <div className="p-5">
        <div className="text-[#c9a24a] uppercase text-[10px] tracking-[0.3em]">
          {product.category}
        </div>
        <div className="font-serif text-[#f4ead5] text-[15px] mt-2 leading-snug line-clamp-2 min-h-[42px]">
          {product.name}
        </div>
        {product.description && (
          <div className="text-[#c4bba6] text-[12.5px] mt-2 leading-relaxed line-clamp-3 min-h-[52px]">
            {product.description}
          </div>
        )}
        <div className="mt-3 text-[#e9d9b0] text-sm">{formatINR(product.price)}</div>
      </div>
    </a>
  );
};

export default ProductCard;
export { formatINR };
